import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

export default function RejectionReasonDialog({ isOpen, onClose, onSubmit }) {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(reason);
    setReason('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#0F172A] border-white/10 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] text-xl font-bold">Reject Commitment</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium mb-2 text-[#94A3B8]">Reason for Rejection (Optional)</label>
            <textarea 
              value={reason} 
              onChange={(e) => setReason(e.target.value)} 
              placeholder="Enter reason..."
              rows="3"
              className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg focus:border-[#EF4444] focus:ring-1 focus:ring-[#EF4444] outline-none text-white placeholder:text-white/20 resize-none" 
              autoFocus
            />
          </div>
          <DialogFooter className="gap-2 sm:gap-0 mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors text-sm font-medium">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-[#EF4444] text-white font-bold rounded-lg hover:bg-[#DC2626] transition-all text-sm">Reject Commitment</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
